import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Edit from "@material-ui/icons/Edit";
import Add from "@material-ui/icons/Add";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import PersonIcon from "@material-ui/icons/Person";
import HistoryIcon from "@material-ui/icons/History";
import PaymentIcon from "@material-ui/icons/Payment";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import GuestDialog from "../GuestDialog/GuestDialog.jsx";
import PaymentsView from "../PaymentsView/PaymentsView.jsx";
import PaymentBackDialog from "../PaymentBack/PaymentBack.jsx";
import ResHistoryView from "../ResHistoryView/ResHistoryView.jsx";
import renderField from "../PropertiesList/renderer/index.jsx";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import LoadingPaper from "../LoadingPaper/LoadingPaper.jsx";
import IconButton from "@material-ui/core/IconButton";
import ReplayIcon from "@material-ui/icons/Replay";
import { Link } from "react-router-dom";

import EditReservationPopup from "./EditReservationPopup.jsx";
import NoShowPopup from "./NoShowPopup.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

import {
    formatDate,
    formatMoney,
    formatGuestName,
    formatStatus,
} from "../../lib/helperFuncs.jsx";
import { UNAVAILABILITY_MESSAGE, MATERIAL_UI_PROPS } from "../../lib/data";
import {
    editButtonTheme as back,
    toggleButtonTheme as submit,
} from "../../config/theme";
import ServicesDialog from "../ServicesDialog/ServicesDialog.jsx";
import { TableHead, TextField } from "@material-ui/core";
import moment from "moment";
import { COUNTRIES } from "./help/CountriesArray";
import styles from "./SingleReservation.module.css";
import Tooltip from "@material-ui/core/Tooltip";
import { Cancel, Reply } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import DOMPurify from "dompurify";

const useStyles = makeStyles({
    dataTd: {
        borderBottom: "none",
        fontSize: "1rem",
    },
    labelTd: {
        maxWidth: "250px",
        borderBottom: "none",
    },
    buttonTd: {
        maxWidth: "250px",
        borderBottom: "none",
    },
    priceDates: {
        border: "1px solid grey",
        padding: "10px",
        marginTop: "10px",
    },
    priceFlex: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
    },
    trCommentMain: {
        border: "2px solid black",
        fontWeight: "bold",
        fontSize: "20px",
    },
    trComment: {
        border: "1px solid black",
        fontWeight: "bold",
    },
    trCommentSlave: {
        border: "1px solid black",
    },
    backLine: {
        backgroundColor: "#ededed",
    },
});

const NO_DATA_LAYOUT = "Не заполнено";

const SingleReservation = (props) => {
    const { id } = useParams();
    const [openGuestDialog, setOpenGuestDialog] = useState(false);
    const [openPaymentBackDialog, setOpenPaymentBackDialog] = useState(false);
    const [openPaymentsDialog, setOpenPaymentsDialog] = useState(false);
    const [openResHistoryDialog, setOpenResHistoryDialog] = useState(false);
    const [openServicesDialog, setOpenServicesDialog] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openCancelDialog, setOpenCancelDialog] = useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const classes = useStyles();
    const reservation = props.pickedReservation || null;
    const fields = { ...props.fields };
    const [loading, setLoading] = useState(false);
    const [noShowVisible, setNoShowVisible] = useState(false);
    const [loadingRefunds, setLoadingRefunds] = useState(false);
    const [hasRefunds, setHasRefunds] = useState(false);
    const [hasCashback, setHasCashback] = useState(false);
    const [hasActiveRefunds, setActiveHasRefunds] = useState(false);
    const [isEditingExternalId, setIsEditingExternalId] = useState(false);
    const [priceFirstDay, setPriceFirstDay] = useState(0);
    const [isAddingPaid, setIsAddingPaid] = useState(false);
    const [initialStatus, setInitialStatus] = useState(null);
    const [cancelReasons, setCancelReasons] = useState([]);
    const [loadingReasons, setLoadingReasons] = useState(false);
    const [customReason, setCustomReason] = useState("");
    useEffect(() => {
        if (openCancelDialog) {
            setLoadingReasons(true);
            axios
                .get("/api/cancellation_reasons")
                .then((response) => {
                    setCancelReasons(response.data.map((item) => item.reason));
                })
                .catch((error) => console.error(error))
                .finally(() => setLoadingReasons(false));
        }
    }, [openCancelDialog]);

    const handleCancelReservation = () => {
        const finalReason =
            cancelReason === "Другое" ? customReason : cancelReason;
        if (finalReason) {
            setLoading(true);
            reservation.status = "cancelled";
            reservation.cancel_reason = finalReason;
            props.submitAction();
            setOpenCancelDialog(false);
        }
    };

    const changeAddingPaid = () => {
        setIsAddingPaid((pr) => {
            if (pr) {
                props.fieldUpdateHandler("new_payment", "");
            }
            return !pr;
        });
    };

    const handleStateNewPayment = (e) => {
        props.fieldUpdateHandler("new_payment", e.target.value);
    };

    const handleStartEditExternalId = () => {
        setIsEditingExternalId(true);
    };

    const handleCancelEditExternalId = () => {
        setIsEditingExternalId(false);
    };

    const handleChangeExternalId = (e) => {
        props.fieldUpdateHandler("external_id", e.target.value);
    };

    if (props.fields && reservation) {
        if (fields.status.type === "enum") {
            fields.status.value = reservation.status;
            fields.status.name = "status";
        }
    }

    const activeRates = props?.rates?.filter((rates) => rates.active);
    const activeRoomTypes = props?.roomTypes?.filter(
        (roomTypes) => roomTypes.active,
    );

    const toggleModal = () => {
        if (!loading) {
            setOpenEdit(!openEdit);
        }
    };

    const fetchTransaction = (variant = "") => {
        axios
            .get(
                `/manager/data/transaction_resend/${reservation?.id}?variant=${variant}`,
            )
            .then((response) => {
                if (response.data.success) {
                    props.initAction(reservation.id);
                    alert(response.data.message);
                } else if (!response.data.success) {
                    alert(response.data.message);
                }
            })
            .catch((error) => console.error(error));
    };

    const resendTransactionHandle = () => {
        fetchTransaction();
    };

    const hotResendTransactionHandle = () => {
        fetchTransaction("hot");
    };

    const togglePopup = (e) => {
        e.preventDefault();
        if (!loading) {
            setNoShowVisible(!noShowVisible);
        }
    };

    const buttons = [
        {
            type: back,
            icon: <ArrowBackIcon />,
            caption: "Вернуться",
            link: props.getBackLink,
        },
    ];

    useEffect(() => props.initAction(id), []);

    useEffect(() => {
        if (reservation?.status && initialStatus === null) {
            setInitialStatus(reservation.status);
        }
    }, [reservation]);

    const handleSaveClick = () => {
        if (
            fields?.status?.value === "cancelled" &&
            initialStatus !== "cancelled"
        ) {
            setOpenCancelDialog(true);
        } else {
            setLoading(true);

            if (props.submitAction() === false) {
                setLoading(false);
            }
        }
    };

    if (props.editable) {
        buttons.push({
            type: submit,
            icon: loading ? (
                <CircularProgress size={24} color="inherit" />
            ) : (
                <SaveIcon />
            ),
            caption: loading ? "Сохранение..." : "Сохранить",
            action: handleSaveClick,
            disabled: loading,
        });
    }

    useEffect(() => {
        if (Array.isArray(props?.refunds)) {
            setHasRefunds(
                props.refunds.some(
                    (refund) =>
                        refund.reservation_id === reservation?.id &&
                        (refund?.cashback !== 1 || !refund?.cashback),
                ),
            );
            setHasCashback(
                props.refunds.some(
                    (refund) =>
                        refund.reservation_id === reservation?.id &&
                        (refund?.cashback == 1 || refund?.cashback),
                ),
            );
            setActiveHasRefunds(
                props.refunds.some(
                    (refund) =>
                        refund.reservation_id === reservation?.id &&
                        refund.status === "Ждет выполнения" &&
                        (refund?.cashback !== 1 || !refund?.cashback),
                ),
            );
            setLoadingRefunds(true);
        }
    }, [props?.refunds, reservation?.id]);

    useEffect(() => {
        if (Array.isArray(reservation?.pricesDates)) {
            const match =
                reservation?.pricesDates[0].match(/Общая сумма (\d+) ₽/);
            setPriceFirstDay(match ? parseInt(match[1], 10) : 0);
        }
    }, [reservation]);

    const saveVaucher = () => {
        axios
            .get(
                `${reservation.api_url_shop}/index.php?route=api/booking/getVoucherLink&order_id=${reservation.order_number}`,
            )
            .then((response) => {
                if (response.data?.voucher_url) {
                    window.open(response.data.voucher_url);
                } else {
                    alert("Ссылка на ваучер не существует");
                }
            })
            .catch((error) => console.error(error));
    };

    const handleAcceptPaymentOnline = () => {
        setLoading(true);
        axios.post(`/manager/data/reservations/${reservation.hotel_id}/${reservation.id}/accept_online_payment`)
            .then(response => {
                alert("Оплата онлайн успешно активирована");
                props.initAction(reservation.id);
            })
            .catch(error => {
                alert("Произошла ошибка");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const sendGuestVaucher = () => {
        const data = {
            url_shop: reservation.api_url_shop,
            order_number: reservation.order_number,
            email: reservation.guest.email,
            hotel_id: reservation.hotel_id,
        };
        axios
            .post("/manager/data/send_voucher", data)
            .then((response) => {
                if (response.data?.result) {
                    alert(response.data.message);
                } else {
                    alert("Произошла ошибка");
                }
            })
            .catch((error) => console.error(error));
    };

    const sendLink = () => {
        axios
            .get(`/manager/data/reservations/set_need_link/${reservation.id}`)
            .then((response) => {
                if (response.data.success) {
                    props.initAction(reservation.id);
                }
            })
            .catch((error) => console.error(error));
    };

    // const sendVaucher = () => {
    //     axios.get('index.php?route=api/booking/getVoucherLink' + reservation.order_number)
    //         .then()
    //         .catch(error => console.error(error))
    // }

    const servicesDialog = openServicesDialog && (
        <ServicesDialog
            services={reservation?.services}
            setOpenServicesDialog={setOpenServicesDialog}
            openServicesDialog={openServicesDialog}
            fields={fields}
        />
    );

    const resHistoryDialog = openResHistoryDialog && (
        <ResHistoryView
            history={reservation.history}
            setOpenResHistoryDialog={setOpenResHistoryDialog}
            openResHistoryDialog={openResHistoryDialog}
            fields={fields}
        />
    );

    const guestDataDialog = openGuestDialog && (
        <GuestDialog
            openGuestDialog={openGuestDialog}
            curGuest={reservation.denormalized?.guest || props.curGuest}
            guestFromRes={reservation.guest}
            setOpenGuestDialog={setOpenGuestDialog}
            getGuestData={props.getGuestData}
            guestId={reservation.guest_id}
            reservationId={reservation?.id}
        />
    );

    const paymentBackDialog = openPaymentBackDialog && (
        <PaymentBackDialog
            openPaymentBackDialog={openPaymentBackDialog}
            setOpenPaymentBackDialog={setOpenPaymentBackDialog}
            cancelPolicy={reservation?.cancelationPolicy}
            dateIn={reservation?.date_in}
            dateOut={reservation?.date_out}
            reservationId={reservation?.id}
            guestId={reservation?.guest_id}
            sumTotal={reservation?.total}
            paidAmount={reservation?.paid_amount}
            refundedAmount={reservation?.refunded_amount}
            hotelId={reservation?.hotel.id}
            paymentNumber={reservation?.number}
            orderNumber={reservation?.order_number}
            setActiveHasRefunds={setActiveHasRefunds}
            setHasRefunds={setHasRefunds}
            priceFirstDay={priceFirstDay}
            paymentMade={reservation?.payments?.length ? true : false}
        />
    );

    const resPaymentsDialog = openPaymentsDialog && (
        <PaymentsView
            payments={reservation.payments}
            refunds={reservation?.refunds}
            setOpenPaymentsDialog={setOpenPaymentsDialog}
            openPaymentsDialog={openPaymentsDialog}
            initAction={props.getPaymentTypeNames}
            paymentTypeNames={props.paymentTypeNames}
            reservation={reservation}
            reLoad={props.initAction}
            loading={loading}
        />
    );

    let commentObject = 1;
    let comment = "Данные гостей не указаны.";

    if (reservation?.comment != undefined && reservation?.comment != "") {
        try {
            commentObject = JSON.parse(reservation.comment);
        } catch (error) {
            if (typeof reservation.comment == "string") {
                commentObject = JSON.parse(parseComment(reservation.comment));
                if (commentObject === 1) {
                    comment = "Данные гостей не распознаны";
                }
            }
        }
    }

    let commentIsJson = false;

    if (commentObject != 1) {
        commentIsJson = true;

        const filteredAdults = commentObject?.adults?.filter((adult) => {
            const isChiefGuest = adult?.name?.includes("[chief_guest]");
            return !isChiefGuest;
        });

        comment = (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.trCommentMain}>
                            Взрослые
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.trComment}>Имя</TableCell>
                        <TableCell className={classes.trComment}>
                            Фамилия
                        </TableCell>
                        <TableCell className={classes.trComment}>
                            Страна
                        </TableCell>
                        <TableCell className={classes.trComment}>
                            Дата рождения
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredAdults?.map(
                        (adult, index) =>
                            index % 4 === 0 &&
                            filteredAdults[index]?.value && (
                                <TableRow key={filteredAdults[index]?.name}>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {filteredAdults[index]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {filteredAdults[index + 1]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            COUNTRIES[
                                                filteredAdults[index + 2]?.value
                                            ]
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {filteredAdults[index + 3]?.value}
                                    </TableCell>
                                </TableRow>
                            ),
                    )}
                </TableBody>
                <TableCell
                    style={{ border: "none", padding: "10px" }}
                ></TableCell>
                {(commentObject?.childrens?.length > 0 ||
                    commentObject?.babies?.length > 0 ||
                    commentObject?.infants?.length > 0) && (
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.trCommentMain}>
                                Дети
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.trComment}>
                                Имя
                            </TableCell>
                            <TableCell className={classes.trComment}>
                                Фамилия
                            </TableCell>
                            <TableCell className={classes.trComment}>
                                Страна
                            </TableCell>
                            <TableCell className={classes.trComment}>
                                Дата рождения
                            </TableCell>
                            <TableCell className={classes.trComment}>
                                Возраст на дату заселения
                            </TableCell>
                        </TableRow>
                    </TableHead>
                )}
                <TableBody>
                    {commentObject?.childrens?.map(
                        (child, index) =>
                            index % 4 === 0 && (
                                <TableRow
                                    key={commentObject.childrens[index]?.name}
                                >
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {commentObject.childrens[index]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            commentObject.childrens[index + 1]
                                                ?.value
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            COUNTRIES[
                                                commentObject.childrens[
                                                    index + 2
                                                ]?.value
                                            ]
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            commentObject.childrens[index + 3]
                                                ?.value
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {getAgeOnIn(
                                            commentObject.childrens[index + 3]
                                                ?.value,
                                            reservation.date_in,
                                        )}
                                    </TableCell>
                                </TableRow>
                            ),
                    )}

                    {commentObject?.babies?.map(
                        (child, index) =>
                            index % 4 === 0 && (
                                <TableRow
                                    key={commentObject.babies[index]?.name}
                                >
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {commentObject.babies[index]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {commentObject.babies[index + 1]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            COUNTRIES[
                                                commentObject.babies[index + 2]
                                                    ?.value
                                            ]
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {commentObject.babies[index + 3]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {getAgeOnIn(
                                            commentObject.babies[index + 3]
                                                ?.value,
                                            reservation.date_in,
                                        )}
                                    </TableCell>
                                </TableRow>
                            ),
                    )}

                    {commentObject?.infants?.map(
                        (child, index) =>
                            index % 4 === 0 && (
                                <TableRow
                                    key={commentObject.infants[index]?.name}
                                >
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {commentObject.infants[index]?.value}
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            commentObject.infants[index + 1]
                                                ?.value
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            COUNTRIES[
                                                commentObject.infants[index + 2]
                                                    ?.value
                                            ]
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {
                                            commentObject.infants[index + 3]
                                                ?.value
                                        }
                                    </TableCell>
                                    <TableCell
                                        className={classes.trCommentSlave}
                                    >
                                        {getAgeOnIn(
                                            commentObject.infants[index + 3]
                                                ?.value,
                                            reservation.date_in,
                                        )}
                                    </TableCell>
                                </TableRow>
                            ),
                    )}
                </TableBody>
                <TableCell
                    style={{ border: "none", padding: "10px" }}
                ></TableCell>
                {commentObject?.comment_text && (
                    <>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.trCommentMain}>
                                    Комментарий гостя
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className={classes.trCommentSlave}>
                                    {commentObject?.comment_text}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </>
                )}
            </Table>
        );
    }

    //Разрешить менеджеру редактировать заявки вплоть до конца даты выезда
    if (
        moment().isSameOrBefore(reservation?.date_out, "day") &&
        loadingRefunds &&
        !hasRefunds
        // moment().isBefore(dateIn, 'day') || (dateIn && moment().isSame(dateIn, 'day') && moment().hour() < 12)
    ) {
        buttons.push({
            icon: <Edit />,
            caption: "Изменить",
            action: toggleModal,
        });
    }

    if (reservation?.noShow) {
        buttons.push({
            icon: <Edit />,
            caption: "NoShow",
            action: togglePopup,
        });
    }

    if (
        (!(
            reservation?.status === "new" &&
            reservation?.payment_method.id === 2
        ) ||
            reservation?.status !== "cancelled") &&
        loadingRefunds &&
        !hasRefunds
    ) {
        buttons.push({
            icon: <SaveIcon />,
            caption: "Скачать ваучер",
            action: saveVaucher,
        });

        buttons.push({
            icon: <SaveIcon />,
            caption: "Отправить ваучер гостю на почту",
            action: sendGuestVaucher,
        });
    }

    if (reservation?.payment_method?.id !== 2 && (reservation?.status === "new" || reservation?.status === "approved")) {
        buttons.push({
            icon: <PaymentIcon />,
            caption: "Принять оплату онлайн",
            action: handleAcceptPaymentOnline,
            disabled: loading
        });
    }

    let totalPayments = reservation?.payments?.reduce((sum, p) => {
        return sum + parseFloat(p.amount);
    }, 0);

    if (
        reservation?.status !== "cancelled" && (
            (
                reservation?.status === "new"
                && reservation?.payment_method.id === 2
                && reservation?.payments.length === 0
                && !reservation?.need_link
            )
            || (
                reservation?.payment_method.id === 2
                && totalPayments < reservation?.total
                && !reservation?.need_link
            )
        )
    ) {
        buttons.push({
            icon: <SaveIcon />,
            caption: "Отправить ссылку на оплату",
            action: sendLink,
        });
    }

    // buttons.push({
    //     type: submit,
    //     icon: <SaveIcon />,
    //     caption: "Отправить ваучер по смс",
    //     action: sendVaucher,
    // });

    const refundLink = `/hotels/${reservation?.hotel_id}/refund`;

    return reservation ? (
        <Paper key={"reservation"} elevation={3}>
            <Box p={4}>
                <Typography mb={3} variant={"h5"}>
                    {props.editable
                        ? `Редактирование бронирования номер: ${reservation.number}`
                        : `Просмотр бронирования номер: ${reservation.number}`}
                </Typography>
            </Box>
            {resHistoryDialog}
            {guestDataDialog}
            {paymentBackDialog}
            {resPaymentsDialog}
            {servicesDialog}
            <TableContainer>
                <Table aria-label="customized table">
                    <TableBody>
                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Отель
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation.denormalized?.hotel?.name
                                    ? reservation.denormalized?.hotel?.name
                                    : reservation.hotel?.name
                                      ? reservation.hotel?.name
                                      : UNAVAILABILITY_MESSAGE}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Дата создания
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.created_at &&
                                    formatDate(reservation.created_at)}
                            </TableCell>
                            {props.editable ? (
                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        startIcon={<HistoryIcon />}
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={() => {
                                            setOpenResHistoryDialog(true);
                                        }}
                                    >
                                        История изменений
                                    </Button>
                                </TableCell>
                            ) : null}
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Номер заказа
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.order_number ?? "Номер не задан"}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Промокод
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.promo_code ?? "- - -"}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={`${classes.labelTd}`}>
                                Гость
                            </TableCell>
                            <TableCell className={`${classes.dataTd}`}>
                                {formatGuestName(
                                    reservation.denormalized?.guest
                                        ? reservation.denormalized?.guest
                                        : reservation.guest
                                          ? reservation.guest
                                          : UNAVAILABILITY_MESSAGE,
                                )}
                            </TableCell>
                            {props.editable ? (
                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        startIcon={<PersonIcon />}
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={() => setOpenGuestDialog(true)}
                                    >
                                        Просмотр данных гостя
                                    </Button>
                                </TableCell>
                            ) : null}
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Дата заезда
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.date_in &&
                                    formatDate(reservation.date_in)}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Дата выезда
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.date_out &&
                                    formatDate(reservation.date_out)}{" "}
                                {reservation?.is_check_out > 0 && (
                                    <strong>(выехал)</strong>
                                )}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Категория номера
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation.denormalized?.room_type?.name
                                    ? reservation.denormalized?.room_type?.name
                                    : reservation.room_type?.name
                                      ? reservation.room_type?.name
                                      : UNAVAILABILITY_MESSAGE}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Тариф
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation.denormalized?.rate?.name
                                    ? reservation.denormalized?.rate?.name
                                    : reservation.rate?.name
                                      ? reservation.rate?.name
                                      : UNAVAILABILITY_MESSAGE}
                            </TableCell>
                        </TableRow>

                        {reservation?.mayVisibleHRSButton === 1 && (
                            <TableRow className={styles.zebra}>
                                <TableCell className={classes.labelTd}>
                                    Статус транзакции
                                </TableCell>

                                {reservation?.transactionStatus ==
                                "success_error" ? (
                                    <TableCell className={classes.dataTd}>
                                        <Tooltip
                                            title={
                                                "Не получен id от PMS, обновление брони в PMS не возможно"
                                            }
                                        >
                                            <svg
                                                version="1.1"
                                                id="Layer_1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 286.054 286.054"
                                                xmlSpace="preserve"
                                                style={{
                                                    enableBackground:
                                                        "new 0 0 286.054 286.054",
                                                    width: "35px",
                                                }}
                                            >
                                                <g>
                                                    <path
                                                        style={{
                                                            fill: "#E2574C",
                                                        }}
                                                        d="M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027 c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236 c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209 S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972 c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723 c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843 C160.878,195.732,152.878,187.723,143.036,187.723z"
                                                    />
                                                </g>
                                            </svg>
                                        </Tooltip>
                                    </TableCell>
                                ) : (
                                    <TableCell className={classes.dataTd}>
                                        {reservation?.transactionStatus}
                                    </TableCell>
                                )}

                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={hotResendTransactionHandle}
                                    >
                                        Отправить в PMS
                                    </Button>
                                </TableCell>

                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={resendTransactionHandle}
                                    >
                                        Добавить в журнал обмена с PMS
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )}

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                ID в АСУ
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {isEditingExternalId ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            value={
                                                reservation?.external_id || ""
                                            }
                                            onChange={handleChangeExternalId}
                                            inputProps={{
                                                inputMode: "numeric",
                                                pattern: "[0-9]*",
                                                min: "1",
                                            }}
                                            style={{ width: "150px" }}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={handleCancelEditExternalId}
                                            disabled={loading}
                                        >
                                            <ArrowBackIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        {reservation?.external_id ||
                                            "Не указан"}
                                        <IconButton
                                            size="small"
                                            onClick={handleStartEditExternalId}
                                            style={{ marginLeft: "8px" }}
                                        >
                                            <Edit fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Способ оплаты
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation.payment_method?.name
                                    ? reservation.payment_method?.name
                                    : UNAVAILABILITY_MESSAGE}
                            </TableCell>
                        </TableRow>

                        {reservation?.points_used > 0 && (
                            <TableRow className={styles.zebra}>
                                <TableCell className={classes.labelTd}>
                                    Сумма без скидки
                                </TableCell>
                                <TableCell className={classes.dataTd}>
                                    {formatMoney(
                                        reservation?.total +
                                            reservation?.points_used,
                                    )}
                                </TableCell>
                            </TableRow>
                        )}

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Сумма
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.total &&
                                    formatMoney(reservation.total)}
                            </TableCell>
                            <TableCell className={classes.buttonTd}>
                                {reservation?.hotel?.use_money_returns ? (
                                    <Box className={styles.refundButtons}>
                                        <Tooltip
                                            title={
                                                !loadingRefunds ||
                                                hasActiveRefunds
                                                    ? "Есть активная заявка"
                                                    : ""
                                            }
                                        >
                                            <span>
                                                <Button
                                                    startIcon={
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                        >
                                                            <Reply />
                                                        </Box>
                                                    }
                                                    variant={
                                                        MATERIAL_UI_PROPS
                                                            .varinats.contained
                                                    }
                                                    size={
                                                        MATERIAL_UI_PROPS.sizes
                                                            .small
                                                    }
                                                    onClick={() =>
                                                        setOpenPaymentBackDialog(
                                                            true,
                                                        )
                                                    }
                                                    disabled={
                                                        !loadingRefunds ||
                                                        hasActiveRefunds ||
                                                        initialStatus ===
                                                            "cancelled"
                                                    }
                                                >
                                                    Вернуть ДС
                                                </Button>
                                            </span>
                                        </Tooltip>
                                        <Tooltip
                                            title={
                                                !loadingRefunds || !hasRefunds
                                                    ? "Нет возвратов"
                                                    : ""
                                            }
                                        >
                                            <span>
                                                <Button
                                                    className={
                                                        styles.allRefundButton
                                                    }
                                                    startIcon={
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                        >
                                                            <ReplayIcon />
                                                        </Box>
                                                    }
                                                    variant={
                                                        MATERIAL_UI_PROPS
                                                            .varinats.contained
                                                    }
                                                    size={
                                                        MATERIAL_UI_PROPS.sizes
                                                            .small
                                                    }
                                                    component={Link}
                                                    onClick={() => {
                                                        props.updateGlobalSearch(
                                                            {
                                                                ...props
                                                                    .globalSearch
                                                                    .search
                                                                    .refund,
                                                                reservation_id: `${reservation.id}`,
                                                            },
                                                            "refund",
                                                        );
                                                    }}
                                                    to={refundLink}
                                                    disabled={
                                                        !loadingRefunds ||
                                                        (!hasRefunds &&
                                                            !hasCashback)
                                                    }
                                                >
                                                    Возвраты
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                ) : (
                                    <></>
                                )}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Оплачено
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {reservation?.paid_amount &&
                                        formatMoney(reservation.paid_amount)}
                                    {!isAddingPaid && (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <IconButton
                                                size="small"
                                                onClick={changeAddingPaid}
                                                style={{ marginLeft: "8px" }}
                                            >
                                                <Add fontSize="small" />
                                            </IconButton>
                                        </div>
                                    )}
                                    {isAddingPaid && (
                                        <div
                                            style={{
                                                display: "flex",
                                                marginLeft: "15px",
                                            }}
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                value={reservation.new_payment}
                                                onChange={handleStateNewPayment}
                                                inputProps={{
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]*",
                                                }}
                                                style={{ width: "150px" }}
                                            />
                                            <IconButton
                                                size="small"
                                                onClick={changeAddingPaid}
                                                disabled={loading}
                                            >
                                                <ArrowBackIcon fontSize="small" />
                                            </IconButton>
                                        </div>
                                    )}
                                </div>
                            </TableCell>
                            {props?.editable && (
                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        startIcon={<PaymentIcon />}
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={() =>
                                            setOpenPaymentsDialog(true)
                                        }
                                    >
                                        История оплат
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>

                        {reservation?.points_used > 0 && (
                            <TableRow className={styles.zebra}>
                                <TableCell className={classes.labelTd}>
                                    Потрачено баллов
                                </TableCell>
                                <TableCell className={classes.dataTd}>
                                    {reservation.points_used}
                                </TableCell>
                            </TableRow>
                        )}

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Статус
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {props?.editable
                                    ? renderField(
                                          fields?.status,
                                          props.fieldUpdateHandler,
                                          null,
                                          props?.editable,
                                      )
                                    : formatStatus(
                                          reservation?.status,
                                          props?.fields,
                                      )}
                            </TableCell>
                            <TableCell className={classes.buttonTd}>
                                <Tooltip
                                    title={
                                        initialStatus === "cancelled"
                                            ? "Бронь уже отменена"
                                            : ""
                                    }
                                >
                                    <span>
                                        <Button
                                            startIcon={
                                                <Box display="flex" gap={1}>
                                                    {loading ? (
                                                        <CircularProgress
                                                            size={24}
                                                            color="inherit"
                                                        />
                                                    ) : (
                                                        <Cancel />
                                                    )}
                                                </Box>
                                            }
                                            variant={
                                                MATERIAL_UI_PROPS.varinats
                                                    .contained
                                            }
                                            size={MATERIAL_UI_PROPS.sizes.small}
                                            onClick={() =>
                                                setOpenCancelDialog(true)
                                            }
                                            disabled={
                                                initialStatus === "cancelled"
                                            }
                                        >
                                            Отменить бронирование
                                        </Button>
                                    </span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>

                        {/* Update */}
                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Услуги
                            </TableCell>

                            <TableCell className={classes.dataTd}>
                                {reservation.denormalized?.services?.length ||
                                    reservation.services?.length ||
                                    0}
                            </TableCell>

                            {props?.editable && (
                                <TableCell className={classes.buttonTd}>
                                    <Button
                                        startIcon={<RoomServiceIcon />}
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.contained
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        onClick={() =>
                                            setOpenServicesDialog(true)
                                        }
                                    >
                                        Просмотр списка дополнительных услуг
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Взрослые
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.adults}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Дети
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.children}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Младенцы
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.babies}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Инфанты
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.infant}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                {reservation?.hotel_id === 10
                                    ? "Дополнительное место"
                                    : "Дополнительная кровать"}
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.extra_bed}
                            </TableCell>
                        </TableRow>

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Колыбель
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {reservation?.craddle}
                            </TableCell>
                        </TableRow>

                        {reservation?.oob > 0 && (
                            <TableRow className={styles.zebra}>
                                <TableCell className={classes.labelTd}>
                                    Заказ ООБ
                                </TableCell>
                                <TableCell className={classes.dataTd}>
                                    ДА
                                </TableCell>
                            </TableRow>
                        )}

                        {reservation?.mobile > 0 && (
                            <TableRow className={styles.zebra}>
                                <TableCell className={classes.labelTd}>
                                    Заказ из МП
                                </TableCell>
                                <TableCell className={classes.dataTd}>
                                    ДА
                                </TableCell>
                            </TableRow>
                        )}

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Комментарий
                            </TableCell>
                            <TableCell className={classes.dataTd}>
                                {comment}
                            </TableCell>
                        </TableRow>

                        {reservation?.comment_manager &&
                            reservation.comment_manager !== "" && (
                                <TableRow
                                    className={styles.zebra}
                                    style={{ marginBottom: "10px" }}
                                >
                                    <TableCell className={classes.labelTd}>
                                        Комментарий менеджера
                                    </TableCell>
                                    <TableCell className={classes.dataTd}>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            multiline
                                            minRows={3}
                                            value={
                                                reservation?.comment_manager ||
                                                ""
                                            }
                                            InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            )}

                        <TableRow className={styles.zebra}>
                            <TableCell className={classes.labelTd}>
                                Стоимость по дням
                            </TableCell>
                            <div className={classes.priceFlex}>
                                {reservation?.pricesDates &&
                                    reservation.pricesDates?.map((p, n) => (
                                        <div
                                            key={"nnn" + n}
                                            className={classes.priceDates}
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(p),
                                            }}
                                        ></div>
                                    ))}
                            </div>
                        </TableRow>

                        {!allGuestDataMissing(reservation?.guests) && (
                            <TableRow>
                                <TableCell className={classes.dataTd}>
                                    Гости
                                </TableCell>
                                <TableCell className={classes.dataTd}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography
                                                        style={{
                                                            fontWeight: 400,
                                                        }}
                                                    >
                                                        Гость
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography
                                                        style={{
                                                            fontWeight: 400,
                                                        }}
                                                    >
                                                        Гражданство
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.keys(
                                                reservation?.guests,
                                            )?.map((guestKey, index) => (
                                                <TableRow
                                                    key={`add-guest${index}`}
                                                >
                                                    <TableCell>
                                                        {guestDataMissing(
                                                            reservation?.guests[
                                                                guestKey
                                                            ],
                                                        ) ? (
                                                            NO_DATA_LAYOUT
                                                        ) : (
                                                            <Box>
                                                                {Object.keys(
                                                                    reservation
                                                                        ?.guests[
                                                                        guestKey
                                                                    ],
                                                                )?.map(
                                                                    (
                                                                        ppty,
                                                                        pptyIdx,
                                                                    ) =>
                                                                        ppty !==
                                                                            "citizenship" &&
                                                                        createNameEl(
                                                                            reservation
                                                                                .guests[
                                                                                guestKey
                                                                            ][
                                                                                ppty
                                                                            ],
                                                                            {
                                                                                pptyIdx,
                                                                                index,
                                                                            },
                                                                        ),
                                                                )}
                                                            </Box>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {reservation?.guests[
                                                            guestKey
                                                        ].citizenship ||
                                                            NO_DATA_LAYOUT}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableCell>
                            </TableRow>
                        )}
                        {/* Update */}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box pt={4} pb={4}>
                <ControlButtons items={buttons}></ControlButtons>
                {/* {props.editable ? saveButton : null} */}
                {/*{!commentIsJson && <Typography variant="caption" color="textSecondary">Редактирование данного заказа невозможно.</Typography>}*/}
            </Box>

            <Dialog
                open={openCancelDialog}
                onClose={() => {
                    setOpenCancelDialog(false);
                    setCustomReason("");
                    setCancelReason("");
                }}
            >
                <DialogTitle>Выберите причину отмены</DialogTitle>
                <DialogContent>
                    {loadingReasons ? (
                        <Box display="flex" justifyContent="center" p={3}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <FormControl component="fieldset" fullWidth>
                            <RadioGroup
                                aria-label="cancel-reason"
                                name="cancel-reason"
                                value={cancelReason}
                                onChange={(e) =>
                                    setCancelReason(e.target.value)
                                }
                            >
                                {cancelReasons.map((reason) => (
                                    <FormControlLabel
                                        key={reason}
                                        value={reason}
                                        control={<Radio />}
                                        label={reason}
                                    />
                                ))}
                            </RadioGroup>

                            {cancelReason === "Другое" && (
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    variant="outlined"
                                    label="Укажите причину отмены"
                                    value={customReason}
                                    onChange={(e) =>
                                        setCustomReason(e.target.value)
                                    }
                                />
                            )}
                        </FormControl>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenCancelDialog(false)}
                        color="primary"
                    >
                        Закрыть
                    </Button>
                    <Button
                        onClick={() => {
                            const finalReason =
                                cancelReason === "Другое"
                                    ? customReason
                                    : cancelReason;
                            setCancelReason(finalReason);
                            handleCancelReservation();
                        }}
                        color="secondary"
                        disabled={
                            !cancelReason ||
                            (cancelReason === "Другое" && !customReason) ||
                            loadingReasons
                        }
                    >
                        Отменить бронирование
                    </Button>
                </DialogActions>
            </Dialog>

            {openEdit && (
                <EditReservationPopup
                    open={openEdit}
                    onClose={toggleModal}
                    rates={activeRates}
                    roomTypes={activeRoomTypes}
                    loading={loading}
                    setLoading={setLoading}
                    reservation={reservation}
                    reLoad={props.initAction}
                    commentIsJson={commentIsJson}
                    commentObject={commentObject}
                />
            )}

            {noShowVisible && (
                <NoShowPopup
                    open={noShowVisible}
                    onClose={() => setNoShowVisible(false)}
                    reservation={reservation}
                />
            )}
        </Paper>
    ) : (
        <Paper elevation={3}>
            <LoadingPaper />
        </Paper>
    );
};

const guestDataMissing = (guest) =>
    !guest?.first_name && !guest?.last_name && !guest?.second_name;

const createNameEl = (name, { pptyIdx, index }) =>
    name && (
        <Box key={`property${index}-${pptyIdx}`} component={"span"} mr={0.5}>
            {name}
        </Box>
    );

const allGuestDataMissing = (guests) => {
    if (!guests) return true;

    if (Object.keys(guests).length > 0) {
        let missingGuestData = 0;
        Object.keys(guests).forEach((guestKey) => {
            const curGuest = guests[guestKey];
            if (guestDataMissing(curGuest) && !curGuest?.citizenship)
                ++missingGuestData;
        });

        return !!missingGuestData;
    }
};

SingleReservation.propTypes = {
    initAction: PropTypes.func.isRequired,
    getBackLink: PropTypes.func.isRequired,
    pickedReservation: PropTypes.object,
    fieldUpdateHandler: PropTypes.func,
    fields: PropTypes.object,
    editable: PropTypes.bool,
    submitAction: PropTypes.func,
    getPaymentTypeNames: PropTypes.func,
    paymentTypeNames: PropTypes.array,
    getGuestData: PropTypes.func,
    curGuest: PropTypes.object,
    hasRefunds: PropTypes.bool,
};

export default SingleReservation;

const getAgeOnIn = (birth, target) => {
    const birthDate = moment(birth, "DD.MM.YYYY");
    const targetDate = moment(target, "YYYY-MM-DD");
    return targetDate.diff(birthDate, "years");
};

const getCountryId = (nationality) => {
    return COUNTRIES.findIndex((country) => country === nationality);
};

const fetchUniqId = () => {
    let uniQid;
    try {
        const response = axios.get("/manager/data/reservations/get_uni_qid");
        uniQid = response.data;
    } catch (error) {
        console.error("Error fetching", error);
        return "";
    }

    return uniQid;
};

const parseComment = (comment) => {
    let commentText, stableComment, adults, childrens;

    try {
        let preCommentArr = comment.split(" {");

        if (preCommentArr.length > 1) {
            commentText = preCommentArr[0];
            stableComment = comment.split(commentText + " ");
            stableComment = JSON.parse(stableComment[1]);
        } else {
            const arrComment = comment.split(" Главный гость №");

            const adultsArr = arrComment[0].split("Данные взрослого гостя №");
            commentText = adultsArr[0];

            const childArr = arrComment[1].split(" Данные детского гостя №");

            const chiefGuest = childArr[0].replace(";", "");
            let uniQid = fetchUniqId() ?? ["2343215_23234"];

            setTimeout(function () {}, 3000);

            const adultPrefix = `adult_guests[${uniQid}]`;
            adults = [];
            adultsArr.forEach((str, idx) => {
                if (idx === 0) {
                    adults.push({
                        name: `${adultPrefix}[chief_guest]`,
                        value: chiefGuest,
                    });
                    return;
                }
                const name = str.split("Имя: ");
                const lastName = str.split("Фамилия: ");
                const country = str.split("Гражданство: ");
                const birth = str.split("День рождения: ");

                adults.push({
                    name: `${adultPrefix}[${idx}][firstname]`,
                    value: name[1].split(";")[0],
                });
                adults.push({
                    name: `${adultPrefix}[${idx}][lastname]`,
                    value: lastName[1].split(";")[0],
                });
                adults.push({
                    name: `${adultPrefix}[${idx}][country_id]`,
                    value: getCountryId(country[1].split(";")[0]),
                });
                adults.push({
                    name: `${adultPrefix}[${idx}][birth]`,
                    value: birth[1].split(";")[0],
                });
            });

            const childPrefix = `children_guests[${uniQid}]`;
            childrens = [];
            childArr.forEach((str, idx) => {
                if (idx === 0) {
                    return;
                }
                const name = str.split("Имя: ");
                const lastName = str.split("Фамилия: ");
                const country = str.split("Гражданство: ");
                const birth = str.split("День рождения: ");

                childrens.push({
                    name: `${childPrefix}[${idx}][firstname]`,
                    value: name[1].split(";")[0],
                });
                childrens.push({
                    name: `${childPrefix}[${idx}][lastname]`,
                    value: lastName[1].split(";")[0],
                });
                childrens.push({
                    name: `${childPrefix}[${idx}][country_id]`,
                    value: getCountryId(country[1].split(";")[0]),
                });
                childrens.push({
                    name: `${childPrefix}[${idx}][birth]`,
                    value: birth[1].split(";")[0],
                });
            });
        }
    } catch (e) {
        console.error(e);
        return 1;
    }

    return JSON.stringify({
        adults: stableComment?.adults ?? adults,
        childrens: stableComment?.childrens ?? childrens,
        comment_text: commentText ?? null,
    });
};
